import React, { FC } from "react";
import FiltersContainer from "./spec-filters/FiltersContainer";

// Composant « racine » pour les filtres des spectacles.
const SpecFilters: FC = () => {
  return <FiltersContainer />;
};

export default SpecFilters;
